import { createFileRoute, redirect } from '@tanstack/react-router'

// Keep indexed links under the former name working while supplier intent moves
// to the canonical bra-and-lingerie landing page.
export const Route = createFileRoute('/supplier-lingerie-surabaya')({
  loader: () => {
    throw redirect({ href: '/supplier-bra-lingerie-surabaya', statusCode: 301 })
  },
})
